// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'newspaper';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313.563H1.688c-.622 0-1.125.503-1.125 1.125v14.624c0 .622.503 1.125 1.125 1.125h14.624c.622 0 1.125-.503 1.125-1.125V1.688c0-.62-.503-1.125-1.125-1.125zm-6.188 9.562h4.5m-4.5 2.25h4.5m-4.5 2.25h2.813m-10.125-4.5h4.5m-4.5 2.25h4.5m-4.5 2.25h2.812' />
    <path d='M14.625 2.813H3.375a.563.563 0 0 0-.563.562V6.75c0 .31.252.563.563.563h11.25c.31 0 .563-.252.563-.563V3.375a.562.562 0 0 0-.563-.563z' />
  </g>
);

export const viewBox = '0 0 18 18';
